import { render, staticRenderFns } from "./ProductSale.vue?vue&type=template&id=4a9e1646&"
import script from "./ProductSale.vue?vue&type=script&lang=js&"
export * from "./ProductSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../hoachipshop-ctv/client-ctv/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../hoachipshop-ctv/client-ctv/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
